var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLongevityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_106",
    "data-name": "Group 106",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 138.995,
    height: 140.632,
    viewBox: "0 0 138.995 140.632",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_129",
    "data-name": "Rectangle 129",
    width: 138.995,
    height: 140.632,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M69.087.91A68.639,68.639,0,1,1,.487,69.551,68.617,68.617,0,0,1,69.087.91",
    transform: "translate(1.308 2.443)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M68.6,0A68.639,68.639,0,1,1,0,68.638,68.616,68.616,0,0,1,68.6,0",
    transform: "translate(0 0)",
    fill: "#1a1818",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M39.426,41.461c-3.7,4.146-8.2,9.474-14.117,7.654-4.82-1.478-9.353-8.022-5.259-13.812,1.153-1.632,9.64-10.064,11.3-11.022a8.563,8.563,0,0,1,8.851.243,10.22,10.22,0,0,1,4.518,6.312c3.88-.251,5.229-2.182,6.968-4.072-1.426-6.722-13.108-15.643-24.1-9.507-3.56,1.99-7.322,6.242-9.924,8.9-2.834,2.9-6.032,5.7-6.913,11.663C9.2,48.355,18.245,57.9,28.566,57.4,34.982,57.1,38,54.041,41.025,51c1.706-1.714,8.188-7.617,8.98-9.625a38.508,38.508,0,0,1-5.292.663c-1.89-.007-3.6-.619-5.288-.582",
    transform: "translate(28.404 40.819)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M16.861,26.633c1.367.018,3.291-.619,5.115-.649,8.487-.129,2.1,3.615,11.1-4.846a8.662,8.662,0,0,1,8.35-2.311c5.133,1.338,9.533,7.93,5.557,13.874-1.12,1.677-9.312,9.865-11.125,10.919-5.189,3.029-11.232.553-13.594-6.46a7.363,7.363,0,0,0-3.8,1.106,16.986,16.986,0,0,0-2.679,2.369c-1.153,1.732,2.189,5.41,3.022,6.379a17.051,17.051,0,0,0,14.641,5.649c6.4-.7,9.43-4.44,12.466-7.506,2.863-2.889,7.377-6.427,9.275-11,6.64-15.993-13.907-32.635-28.651-17.806l-7.492,7.5c-.763.836-1.511,2.019-2.185,2.779",
    transform: "translate(41.739 28.443)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongevityIcon);
export default __webpack_public_path__ + "static/media/longevity-icon.fcad2ea8cb7daf983953f30737634130.svg";
export { ForwardRef as ReactComponent };